<div class="welcomePanel padding-content">
  <div class="welcomeHeader">
    <div class="welcomeText">
      <h1>Welcome {{view.userName}} !</h1>
      <p>Thank you for purchasing Threat Manager</p>
    </div>
    <div  class="InfoHelp">
      <span><a href="mailto:support@alertlogic.com" target="_top">Need Help</a> or <a href="mailto:info@alertlogic.com" target="_top">24X7 Monitoring?</a></span>
      <span>Call Us: 877.484.8383</span>
    </div>
  </div>
  <div>
    <hr>
    <br>
    <p>Creating an environment, and then installing appliances and agents complete the final steps to set up Threat Manager.</p>
    <ol>
      <li>Sign up. (done)</li>
      <li>Create account. (done)</li>
      <li>Confirm identity. (done)</li>
      <li>Create user. (done)</li>
      <li>Create environment. (current step)</li>
      <li>Install appliances & agents.</li>
    </ol>
  </div>
  <div>
    <div class="step currentStep">
      <h2>Step 5: Create environment</h2>
      <span>current step</span>
    </div>
    <hr>
    <br>
    <p>The Deployments page displays all the Amazon Web Services and Microsoft Azure environments we discover, and allows you to set up and manage our ability to access your assets in those environments. Click “Create Environment” to access the Deployments page and create your AWS or Azure environments. After you create your environments, return to this page to install appliances and agents and complete set up of Threat Manager.</p>
    <button  class="welcomeButton" (click)="openTab('urlCreateEnvironment')" > Create environment </button>
    <br>
  </div>
  <div>
      <div class="step">
        <h2>Step 6: Install appliances & agents</h2>
      </div>
      <hr>
      <br>
      <p>You must install appliances first, and then agents before Alert Logic can gather information about your assets. This installation is the final step to set up Threat Manager.</p>
      <button  class="welcomeButton" (click)="openTab('urlInstallAppliancesAndAgents')"> Install appliances & agents </button>
    </div>
</div>